import React, { PureComponent } from 'react'
import T from 'prop-types'
import _ from 'lodash'
import IT from 'react-immutable-proptypes'
import Schema from '../Schema'
import {
  // TextInput,
  ScrollBars,
  // CircleLoader,
  AnimateHeight,
  SaveButton,
  ErrorState,
  // Button
} from 'react-base'
import { is, Map } from 'immutable'
import {
  FORM_STYLES,
  DEFAULT_FORM_STYLE
} from '../types'
// import {
//   FIELD_OPTIONS_SHAPE,
//   CUSTOM_INPUTS_SHAPE,
//   SCHEMA_SHAPE
// } from '../shapes'
import Inputs from './Inputs'
import {
  pluralize
} from 'pw-formatters'

const SAVE_SUCCESS_MSG_TIMEOUT = 5000 // ms that "save success" message is displayed

export default class Form extends PureComponent {
  static displayName = 'Schemer.Form'

  static propTypes = {
    className: T.string,
    style: T.oneOf(Object.keys(FORM_STYLES)),
    error: T.any,

    isLoading: T.bool.isRequired,
    isSaving: T.bool.isRequired,
    readOnly: T.bool.isRequired,

    // schema: SCHEMA_SHAPE.isRequired,
    initialValues: IT.map, // TODO formal definition?
    // currentValues: IT.map,
    validate: T.func, // If passed, will be passed whole formValue after each valid input change. If a string is returned the form is considered invalid

    onSave: T.func.isRequired,
    onSaveArgs: T.array,
    onCancel: T.func,
    onReset: T.func,
    // customInputs is a map of schema fieldName keys to React components
    // customInputs: CUSTOM_INPUTS_SHAPE,
    // fieldOptions: FIELD_OPTIONS_SHAPE
  }

  static defaultProps = {
    style: DEFAULT_FORM_STYLE,
    fieldOptions: Map(),
    customInputs: Map()
  }

  state = {
    pendingValues: Map(),
    formInvalid: null,
    invalidMessages: Map(), // Matches shape of pendingValues
    saveSuccess: false,
    showAllValidationErrors: false,
    errorSuppressed: false
  }


  componentWillMount() {
    this._isMounted = true
    this._tempInvalidMessages = {}
    this._debouncedSetInvalidMessages = _.debounce(this._setInvalidMessages, 150)
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  _setInvalidMessages = () => {
    const {
      invalidMessages
    } = this.state
    const newInvalidMessages = Map(this._tempInvalidMessages)
    if (!is(invalidMessages, newInvalidMessages)) {
      this.setState({
        invalidMessages: newInvalidMessages
      })
    }
  }

  _setSaveSuccessClearer = () => {
    setTimeout(
      () => {
        if (this._isMounted) {
          this.setState({
            saveSuccess: false
          })
        }
      },
      SAVE_SUCCESS_MSG_TIMEOUT
    )
  }

  componentWillReceiveProps(nextProps) {
    console.log('~~SchemerForm getting props... ', this.props, nextProps)
    if (!nextProps.error) {
      if (this.props.isSaving && !nextProps.isSaving && !nextProps.error) {
        // Object was saved
        this.setState({
          pendingValues: Map(),
          saveSuccess: true
        }, this._setSaveSuccessClearer())
      }
      // if (
      //   nextProps.entity &&
      //   ((this.props.isSaving && !nextProps.isSaving) ||
      //   (this.props.isLoading && !nextProps.isLoading)))
      // {
      //   // Save or load completed, set initial form values
      //   const bulkEditableFields = getEditableFieldKeys()

      //   this.setState({
      //     initialFormValues: nextProps.entity.filter(keyIn(bulkEditableFields))
      //   })
      // }
    }
    if (nextProps.error !== this.props.error) {
      this.setState({
        errorSuppressed: false // reset whenever error changes
      })
    }
  }


  handleSaveClick = () => {
    const {
      onSave,
      onSaveArgs=[]
    } = this.props
    const {
      pendingValues
    } = this.state

    console.log('Save Click -- FIXME check for all required fields once more')

    onSave(pendingValues, ...onSaveArgs)
  }

  handleFormSubmit = () => {
    console.log('FORM SUBMIT Click -- FIXME check for all required fields once more')

  }

  handleResetClick = () => {
    this.setState({
      pendingValues: Map(),
      errorSuppressed: true // suppress any existing errors
    })
  }

  handleInputChange = (newValue, fieldName) => {
    const {
      initialValues
    } = this.props
    let {
      pendingValues
    } = this.state
    const initialValue = initialValues.get(fieldName)
    if (is(newValue, initialValue)) {
      pendingValues = pendingValues.delete(fieldName)
    }
    else {
      pendingValues = pendingValues.set(
        fieldName,
        newValue
      )
    }
    this.setState({
      pendingValues
    })
  }

  handleValidationSummaryClick = () => {
    this.setState({
      showAllValidationErrors: !this.state.showAllValidationErrors
    })
  }

  handleSuppressErrorClick = () => {
    this.setState({
      errorSuppressed: true
    })
  }

  // TODO fieldName available if needed (i.e. for scrolling to errored inputs)
  handleValidationChange = (invalidMsg, fieldDisplay/*, fieldName*/) => {
    // Frequent calls to this collect values on a mutable object, which is then set to state after a (debounced) time of no activity
    if (!invalidMsg) {
      delete this._tempInvalidMessages[fieldDisplay]
    }
    else {
      this._tempInvalidMessages[fieldDisplay] = invalidMsg
    }
    this._debouncedSetInvalidMessages()
  }

  render() {
    const  {
      schema,
      isSaving,
      // isLoading,
      error,
      initialValues,
      style,
      readOnly,
      customInputs,
      validate,
      fieldOptions
    } = this.props
    const {
      pendingValues,
      invalidMessages,
      saveSuccess,
      showAllValidationErrors,
      errorSuppressed
    } = this.state

    const currentValues = initialValues && initialValues.merge(pendingValues)

    const isDirty = pendingValues.size > 0

    // Call full form validator if provided
    let formInvalidMsg = null
    if (validate) {
      formInvalidMsg = validate(currentValues)
    }
    const isValid = !formInvalidMsg && (!invalidMessages || invalidMessages.size === 0)

    // action="javascript:void(0)"
    // onSubmit={this.handleFormSubmit}
    return (
      <div
        className={`schemer_form form_style_${readOnly ? 'read_only' : style.toLowerCase()}`}
      >
        <header className="schemer_form_header">Form blah...</header>
        <section className="schemer_form_wrap">
          <ScrollBars slimShady slimShadyDarker>
            <div className="schemer_form_inputs_wrap">
              {schema && currentValues &&
                <Inputs
                  {...{
                    customInputs,
                    fieldOptions,
                    schema,
                    currentValues,
                    readOnly,
                    style,
                  }}
                  onChange={this.handleInputChange}
                  onValidationChange={this.handleValidationChange}
                />
              }
            </div>
          </ScrollBars>
          <div
            className={`schemer_validation_sumamry ${isValid ? '' : 'active'}`}
            onClick={this.handleValidationSummaryClick}
            data-tooltip={`${showAllValidationErrors ? 'Hide' : 'Show'} detailed errors`}
          >
            {formInvalidMsg &&
              <div>{formInvalidMsg}</div>
            }
            {invalidMessages && invalidMessages.size > 0 &&
              <div>Please correct <span>{invalidMessages.size}</span> {pluralize(invalidMessages.size, 'error')} above</div>
            }
          </div>
        </section>
        <AnimateHeight>
          {!isValid && showAllValidationErrors &&
            <div className="validation_summary_items">
              {invalidMessages.entrySeq().map(([fieldId, invalidMsg]) => {
                return (
                  <div
                    key={fieldId}
                    className={`summary_item`}
                  >
                    <span>{fieldId}</span>
                    <div>{invalidMsg}</div>
                  </div>
                )
              })}
              <button
                className={`schemer_close_message_btn btn btn-icon icon-close`}
                onClick={this.handleValidationSummaryClick}
              />
            </div>
          }
          {(isDirty || isSaving) &&
            <footer className={`schemer_form_footer ${isDirty ? 'is_dirty' : ''}`}>
              <button
                className={`reset_btn btn btn-default`}
                onClick={this.handleResetClick}
                type="button"
              >Reset</button>
              <div className="save_wrap">
                <span className="change_summary">{pendingValues.size} {pluralize(pendingValues.size, 'field')} changed</span>
                <SaveButton
                  el="button"
                  type="submit"
                  data-testid="save_btn"
                  className={`schemer_form_save_btn`}
                  dirty={isDirty}
                  disabled={!isDirty}
                  invalid={!isValid}
                  onSave={this.handleSaveClick}
                  saveText={`Save`}
                  saving={isSaving}
                />
              </div>
            </footer>
          }
        </AnimateHeight>
        <div
          className={`schemer_save_success_msg ${saveSuccess ? 'active' : ''}`}
        ><span className="icon icon-checkmark" /> Saved</div>
        <AnimateHeight>
          {!errorSuppressed && error &&
            <div className="schemer_form_error_wrap">
              <ErrorState error={error && error.toJS && error.toJS()} />
              <button
                className={`schemer_close_message_btn btn btn-icon icon-close`}
                onClick={this.handleSuppressErrorClick}
              />
            </div>
          }
        </AnimateHeight>
      </div>
    )
  }
}